// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1JD2O","dragIcon":"Choice_dragIcon__29f4p","left":"Choice_left__1suRf","input":"Choice_input__1FVsw"};